import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatSidenav } from "@angular/material/sidenav";
import {
  Router,
  NavigationEnd,
  ActivatedRoute,
  RouterStateSnapshot,
} from "@angular/router";
import { LandingPageService } from "./../../../../../core/services/landing-page.service";
import { CommanSubscribeService } from "src/app/core/services/comman-subscribe.service";
import { WalletInfo } from "src/app/core/models/wallet-info.model";
import { Subscription } from "rxjs";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ToastrService } from "ngx-toastr";
import { AppService } from "./../../../../../core/services/app.service";
import { StorageService } from "./../../../../../core/services/storage.service";
import { environment } from "src/environments/environment";
import { API } from "../../../../../core/constants";
import { UserService } from "src/app/core/services/user.service";
import * as $ from "jquery";
import { Location } from "@angular/common";
import { AppPaymentTVService } from "src/app/core/services/app-payment-tv.service";
import { MERCH_API } from "src/app/core/constants";
// import { GotoCratdialogComponent } from '../goto-cratdialog/goto-cratdialog.component';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { GotoCratdialogComponent } from "../../../merche-marketplace/goto-cratdialog/goto-cratdialog.component";
import { WalletConnectDialogComponent } from "../../../wallet-connect-dialog/wallet-connect-dialog.component";
import { PubNubService } from "src/app/core/services/pubnub.service";
import { Web3Service } from "src/app/core/services/web3.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  host: {
    "(document:click)": "onClick($event)",
  },
})
export class HeaderComponent implements OnInit {
  isCryptoWallet = environment.required_crypto_wallet;
  @ViewChild("sidenav", { static: false })
  sidenav: MatSidenav;
  @ViewChild("rightsidenav", { static: false })
  rightsidenav: MatSidenav;
  marketplacetext: any;
  menuNames: any = [];
  menuList: any;
  isLiveEvent: boolean = false;
  pId: any = "";
  pName: any = "";
  get cashWalletLink(): string { return (this.pName ? '/' + this.pName : '') + '/user-dashboard/cash-wallet'; }
  vName: any = "";
  id: any = "";
  orgInfo: any;
  routerevents: any;
  userList: any;
  subscriptionRightTabMenuActive: Subscription;
  userInfoSubscription: Subscription;
  userInfo: any = {};
  displayName = "";
  profileName = "";
  channelUrl: string;
  liveEventSubscr: Subscription;
  orgInfoSubscr: Subscription;
  snapshot: RouterStateSnapshot;
  publisherStreamSubscription: Subscription;
  isLiveStream: any;
  hideSignIn: boolean = false;
  subscriptionRightTabUserActive: Subscription;
  refreshCartSccr: Subscription;
  openChat: boolean;
  loggedIn: boolean = false;
  expoInfoSubscr: Subscription;
  expoInfo: any;
  ticket_key: any;
  userIdParam: any;
  event_id: any;
  user_id: any;
  isPubnubChannelAvailable: boolean;
  openPubNubChannel: any;
  isNetworkNotification: boolean = false;
  message: any;
  inviteKey: string;
  ticketStatus: Subscription;
  performerInfoSubscr: Subscription;
  deviceData: Subscription;
  performerInfo: any;
  searchCurrency: any = "";
  currencyJSON: any = [];
  getCurrency: any;
  currenciesList: any = [];
  currency: any;
  currentLocation: any;
  deviceType: any = "";
  assets_url = environment.assets_url;
  clientDetails: any;
  walletInfo: WalletInfo;
  isCartAvailabel: boolean = false;
  cartProdCount: any = 0;
  cartId: any;
  showCartIcon: boolean = false;
  copyLinkPopup: boolean = false;
  cartIdDetails: any;
  cartProducts: any;
  getCartProdCountSubscription: Subscription;
  walletID: string;
  available_balance: any;
  network_name: String;
  crypto_balance: Number;
  cryptoAmount: any;
  cryptoSymbol: string;
  nftNavigation: boolean = false;
  currentChannelName: any;
  constructor(
    private eleRef: ElementRef,
    private location: Location,
    public router: Router,
    private landingPageService: LandingPageService,
    private appService: AppService,
    private commanSubscribeService: CommanSubscribeService,
    private storageService: StorageService,
    private toastr: ToastrService,
    private userService: UserService,
    private pubnubService: PubNubService,
    private ngxLoader: NgxUiLoaderService,
    public route: ActivatedRoute,
    private appPaymentService: AppPaymentTVService,
    public dialog: MatDialog,
    private web3service: Web3Service
  ) {
    this.isCryptoWallet = environment.clientDetails.required_crypto_wallet;
    this.subscriptionRightTabMenuActive = this.commanSubscribeService
      .getLeftTabActiveBasedOnRouterURL()
      .subscribe((message) => {
        if (this.rightsidenav) {
          setTimeout(() => {
            this.rightSideActive();
          }, 1000);
        }
      });
    this.commanSubscribeService.walletInfoSubject.subscribe((result) => {
      if (result?.organizationId === this.commanSubscribeService.orgId) {
        this.walletInfo = result.wallet;
      }
    });

    this.routerevents = router.events.subscribe((val) => {
      this.snapshot = router.routerState.snapshot;
      if (val instanceof NavigationEnd) {
        if (
          this.route &&
          this.route.firstChild &&
          this.route.firstChild.paramMap
        ) {
          this.route.firstChild.paramMap.subscribe((params: any): void => {
            this.channelUrl = this.route.snapshot.pathFromRoot
              .map((o) => o.url[0])
              .join("");
            this.pId = params.params["pId"];
            this.pName = params.params["pName"];
            this.vName = params.params["vName"];
            this.currentChannelName = this.route.snapshot.params.channelName;
            this.id = params.params["id"];
            this.ticket_key = params.params["ticket_key"];
            this.userInfo = this.commanSubscribeService.userInfo;
            console.log("this.userinfo in header", this.userInfo);
            let eventId;
            if (
              !this.storageService.getItem("ticket_key") &&
              this.ticket_key != undefined
            ) {
              this.storageService.setItem("ticket_key", this.ticket_key);
              let id = this.ticket_key;
              if (id && id.includes("-")) eventId = id.split("-");
            }
            if (eventId)
              this.event_id = eventId ? eventId[0] : params.params["id"];
            // this.connectChannel()
            // this.getLiveEvent();
            // this.getOrgInfo();
          });
        }
      }
    });
    // console.log("this.route",route.snapshot.children[0].data.heading);
    if (
      this.route.snapshot.queryParams.vf == "mobile" ||
      (route.snapshot.children[0] &&
        route.snapshot.children[0].data &&
        route.snapshot.children[0].data.heading == "creator-pre_register")
    ) {
      this.hideSignIn = true;
    }
    // this.ticketStatus = this.userService.getTicketStatus().subscribe(response => {
    //   if (response) {
    // this.connectChannel();
    //   }
    // });
  }
  gotoCreator() {
    window.open(environment.VENDOR_PORTAL, "_blank");
  }

  gotoCommunities() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Communities Header Selected - ${userId}`);
    const data = {
      actionType: "community",
      metaData: {
        title: `Communities Header Selected`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commanSubscribeService?.slugInfo?.organization_id || null,
      clickAction: 'community'
    }
    this.commanSubscribeService.sendTriggeredEvent(data);
    //this.router.navigate(["/communities"]); 

  }

  getAvailBalance() {
    this.walletInfo = this.commanSubscribeService.walletByOrg[this.commanSubscribeService.orgId];
    if (!this.walletInfo || Object.keys(this.walletInfo).length == 0) {
      this.commanSubscribeService.getAvailBalance((result) => {
        this.walletInfo = result;
      }, this.commanSubscribeService.orgId);
    }
  }

  onClick(event) {
    //console.log(event);
    if (event.target.id == "") {
      // console.log(this);
      this.rightsidenav.close();
    }
  }
  // copyOrgWebsiteLink() {
  //   this.copyLinkPopup = true;

  // }
  goToCart() {
    if (this.userInfo && this.userInfo.id) {
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      (window as any).umami?.track(`Cart Icon Clicked - ${userId}`);
      const data = {
        actionType: "marketplace",
        metaData: {
          title: `Cart Icon Clicked - ${userId}`,
          timeStamp: new Date().toISOString()
        },
         organizationId: this.commanSubscribeService?.slugInfo?.organization_id || null,
        clickAction: 'marketplace'
      }
      this.commanSubscribeService.sendTriggeredEvent(data);
      this.copyLinkPopup = true;
      let url = MERCH_API.GET_CART_PRODUCTS;
      this.appPaymentService
        .postRequest(url, { cart_id: this.cartId })
        .subscribe(
          (response) => {
            let payload = {
              cart_id: this.cartId,
              cart_products: response.result,
            };
            if (response.status === 0) {
              // this.cartProducts = payload.cart_products;

              this.cartProducts = payload.cart_products;
              //  if(this.cartProducts?.length !== 0){

              this.cartProducts.forEach((element) => {
                element.product_data = JSON.parse(element.product_data);
              });
              // }
              // console.log(this.cartIdDetails , "testtt" );
              //     this.cartIdDetails = payload.cart_products;
              //   console.log(">>>>>>>>>>>>>>>>>>",payload.cart_products)
            } else if (response.status === 1) {
              // this.toaster.error(response.message)
            }
          },
          (error) => {
            this.ngxLoader.stop();
            // this.toaster.error(error)
          }
        );
    }

    // this.router.navigateByUrl('/network-market/product-cart/'+this.cartId);
  }
  gotoCheckout() {
    this.copyLinkPopup = false;
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Cart Icon Clicked - ${userId}`);
    const data = {
      actionType: "marketplace",
      metaData: {
        title: `Cart checkout clicked - ${userId}`,
        timeStamp: new Date().toISOString()
      },
       organizationId: this.commanSubscribeService?.slugInfo?.organization_id || null,
      clickAction: 'checkout'
    }
    this.commanSubscribeService.sendTriggeredEvent(data);
    this.router.navigateByUrl("/network-market/product-cart/" + this.cartId);
  }

  connectChannel() {
    if (this.storageService.getItem("ticket_key")) {
      this.ticket_key = this.storageService.getItem("ticket_key");
      this.event_id = this.ticket_key.split("-")[0];
    }
    if (this.ticket_key) {
      this.event_id = this.ticket_key ? this.ticket_key.split("-")[0] : 0;
      this.user_id = this.ticket_key ? this.ticket_key.split("-")[1] : 0;
    }
    console.log("ticket_key :: ", this.ticket_key);
    if (this.user_id && this.event_id) this.connectPubNubChannels();
  }
  imagedata: any;
  channelName: any;
  ngOnInit() {
    this.web3service.connectedAccId.subscribe(
      (walletId) => (this.walletID = walletId)
    );
    this.network_name = "Ethereum Rinkeby";
    this.web3service.setNetwork(this.network_name);
    // this.getAccountBalance();
    this.web3service.connectedAccId.subscribe(
      (walletId) => (this.walletID = walletId)
    );

    this.clientDetails = environment.clientDetails;
    this.cryptoSymbol = this.clientDetails.crypto_symbol;

    this.commanSubscribeService.getAccountBalance(this.walletID);
    this.cryptoAmount = this.commanSubscribeService
      .getCryptoBalance()
      .subscribe((result) => {
        this.available_balance = result.available_balance;
        console.log(result, "balance");
        this.crypto_balance =
          this.available_balance > 0 ? result.crypto_balance : 0;
      });
    this.marketplacetext = "";
    let mar = this.router.url.includes("/network-market/event")
      ? "event"
      : this.router.url.includes("/network-market/market")
        ? "market"
        : this.router.url.includes("/network-market/nft")
          ? "nft"
          : "";
    this.getlink(mar, false);
    // this.web3service.chainAccountSubject.subscribe((result)=>{
    //   console.log('::::::::::::::result')
    //   this.web3service.setNetwork(environment.clientDetails.network_name);
    //   this.web3service.setContract();
    //     // this.web3service.connectAccount().then(() => {
    //       this.commanSubscribeService.getAccountBalance(this.walletID);
    //     // })
    //   // }
    // })
    this.commanSubscribeService.sendTrackingCode({});
    this.deviceType = this.commanSubscribeService.deviceType;
    this.deviceData = this.commanSubscribeService
      .getAppType()
      .subscribe((response) => {
        this.deviceType = response;
      });
    let perfomerInfoData = this.commanSubscribeService.perfomerInfoData;
    this.performerInfoSubscr = this.commanSubscribeService
      .getPerfomerInfo()
      .subscribe((response) => {
        perfomerInfoData = response;
      });
    if (perfomerInfoData && perfomerInfoData.data?.length>0) {
      this.imagedata = perfomerInfoData.data.Data?.[0]?.org_info?.organization_logo;
      this.channelName = perfomerInfoData.data.Data?.[0]?.channel_name;
    }
    // console.log(perfomerInfoData,perfomerInfoData.data.Data[0].org_info.organization_logo,this.imagedata)
    this.userIdParam = this.route.snapshot.queryParamMap.get("user_id");
    // let checkUser = this.storageService.getItem('user_Info');
    //   if (checkUser && checkUser.access_token) {
    //     this.loggedIn = true;
    //   }
    // this.menuNames = ['home', 'creators', 'organizers', 'fans', 'browse'];

    this.menuNames = ["home", "creators", "fans"];
    this.userInfo = this.commanSubscribeService.userInfo;
    console.log("this.userinfo in header ng onit", this.userInfo);
    this.getName();
    this.userInfoSubscription = this.commanSubscribeService
      .getUserInfo()
      .subscribe((response) => {
        this.userInfo = response;
        this.getName();
        let userInfo = this.storageService.getItem("user_Info");
        console.log(userInfo, "userInfo from storage in header file ");
        if (
          userInfo &&
          userInfo.access_token &&
          this.userInfo &&
          this.userInfo.id
        ) {
          console.log("user logged in");
          this.loggedIn = true;
        } else {
          console.log("user logged out");
          this.loggedIn = false;
        }
        this.getCartProdCount();
      });
    if (this.userInfo && this.userInfo.id) {
      this.getAvailBalance();
    }
    this.expoInfoSubscr = this.commanSubscribeService
      .getExpoInfo()
      .subscribe((response) => {
        this.expoInfo = response;
      });
    let userInfo = this.storageService.getItem("user_Info");
    if (
      userInfo &&
      userInfo.access_token &&
      this.userInfo &&
      this.userInfo.id
    ) {
      this.loggedIn = true;
    }
    // if (this.event_id != 0 && this.user_id != 0 && !this.router.url.includes('network-room')) {
    //   setTimeout(() => {
    //     this.sbService.init();
    //     this.sb = this.sbService.sb;
    //     if(this.user_id && this.event_id)
    //       this.connectPubNubChannels();
    //   }, 5000);
    // }
    this.commanSubscribeService.getCurrenciesJSON().subscribe((result) => {
      Object.keys(result).forEach((element) => {
        let value = element + " - " + result[element];
        this.currencyJSON.push({ currency: value });
        this.currenciesList.push(value);
      });
    });
    this.getCurrency = this.storageService.getItem("currency");
    let locInfo = this.commanSubscribeService.locationInfo;
    this.currentLocation =
      locInfo && Object.keys(locInfo).length > 0
        ? locInfo
        : this.storageService.getItem("current_location");
    if (
      !this.currentLocation ||
      Object.keys(this.currentLocation).length == 0
    ) {
      this.commanSubscribeService.getCurrentLocation((val: any, json: any) => {
        //console.log(json);
        if (val == "fail") {
          this.currentLocation = {};
        } else {
          this.currentLocation = json;
        }
        if (
          this.currentLocation &&
          this.currentLocation.currency &&
          (Object.keys(this.route.snapshot.queryParams).length == 0 ||
            (Object.keys(this.route.snapshot.queryParams).length > 0 &&
              !this.route.snapshot.queryParams.currency))
        ) {
          setTimeout(() => {
            this.setCurrency();
          }, 1000);
        }
      });
    } else if (
      this.currentLocation &&
      Object.keys(this.currentLocation).length > 0
    ) {
      setTimeout(() => {
        this.setCurrency();
      }, 1000);
    }
    $(window).scroll(function () {
      if ($(document).scrollTop() > 40) {
        $(".navbar").addClass("affix");
        $(".logo").removeClass("logo-bg");
        $(".navbar-nav").removeClass("logo-bg");
      } else {
        $(".navbar").removeClass("affix");
        $(".logo").addClass("logo-bg");
        $(".navbar-nav").addClass("logo-bg");
      }
    });
    const ch = this.router.url.split('/')[1] || '';
    const udBase = ch ? `/${ch}/user-dashboard` : '/user-dashboard';
    this.menuList = [
      // {
      //   icon: "fa fa-heart menu-icon mr-10",
      //   name: "Favorites",
      //   link: "user-dashboard/favorites",
      // },
      // {
      //   icon: "fa fa-calendar menu-icon mr-10",
      //   name: "Calendar",
      //   link: "user-dashboard/calendar",
      //   sub_menu: []
      // },

      {
        icon: "fa fa-user menu-icon mr-10",
        name: "My Profile",
        // link: "user-dashboard/profile-settings/basic-info",
        sub_menu: [
          {
            menu_name: "Basic info",
            type: "basic-info",
            link: `${udBase}/profile-settings/basic-info`,
            dualapp: true,
          },
          {
            menu_name: "Change Password",
            type: "change-password",
            link: `${udBase}/profile-settings/change-password`,
            dualapp: true,
          },
        ],
      },
      {
        icon: "fa fa-calendar-check-o menu-icon",
        name: "My Events",
        flag: "true",
        sub_menu: [
          {
            menu_name: "Live",
            type: "live_events",
            link: `${udBase}/My-events`,
            dualapp: true,
          },
          {
            menu_name: "Upcoming",
            type: "upcoming_events",
            link: `${udBase}/My-UpcomingEvents`,
            dualapp: true,
          },
          {
            menu_name: "Past",
            type: "past_events",
            link: `${udBase}/My-PastEvents`,
            dualapp: true,
          },
        ],
      },
      {
        icon: "fa fa-user menu-icon mr-10",
        name: "My Payments",
        // link: "user-dashboard/profile-settings/basic-info",
        sub_menu: [
          {
            menu_name: "Payment Methods",
            type: "payment-methods",
            link: `${udBase}/payment-methods`,
            dualapp: true,
          },
          {
            menu_name: "My Address",
            type: "my-address",
            link: `${udBase}/my-address`,
            dualapp: true,
          },
          {
            menu_name: "Subscribed Channels",
            type: "subscribed-channel",
            link: `${udBase}/subscribed-channel`,
            dualapp: this.deviceType == "browser" ? true : false,
          },
          {
            menu_name: "My Purchases",
            type: "my-purchases",
            link: `${udBase}/my-purchases`,
            dualapp: true,
          },
          {
            menu_name: "Order History",
            type: "order-history",
            link: `${udBase}/order-history`,
            dualapp: true,
          },
          {
            menu_name: "Tips/Donations",
            // icon: "fa fa-handshake-o menu-icon mr-10",
            name: "Tips/Donations",
            link: `${udBase}/tips-donations`,
            dualapp: true,
          },
        ],
      },
      {
        icon: "fa fa-th-large menu-icon",
        name: "My NFT",
        link: "nft-profile",
        sub_menu: [],
        dualapp: true,
        hide: this.isCryptoWallet == 1 ? false : true,
      },
      {
        icon: "fa fa-heart menu-icon",
        name: "My Wishlist",
        link: `${udBase}/My_WishList`,
        sub_menu: [],
        dualapp: true,
      },
      {
        icon: "fa fa-info-circle menu-icon ml-10",
        name: "Crypto Instructions",
        link: `${udBase}/crypto-instructions`,
        sub_menu: [],
        dualapp: true,
        hide: environment.clientDetails.required_crypto_wallet === 0,
      },
    ];
    this.userList = [
      {
        icon: "fa fa-th-large menu-icon mr-10",
        name: "Home",
        link: `/${this.pName}`,
        activeMenuName: "live",
        sub_menu: [],
      },
      {
        icon: "fa fa-user menu-icon mr-10",
        name: "Profile",
        link: `/${this.pName}/profile`,
        sub_menu: [],
      },
      {
        icon: "fa fa-calendar menu-icon mr-10",
        name: "Upcoming",
        link: `/${this.pName}/upcoming-events`,
        sub_menu: [],
      },
      {
        icon: "fa fa-video-camera menu-icon mr-10",
        name: "Videos",
        link: `/${this.pName}/videos`,
        sub_menu: [],
      },
      {
        icon: "fa fa-file-audio-o menu-icon mr-10",
        name: "Audios",
        link: `/${this.pName}/audios`,
        sub_menu: [],
      },
      // {
      //   icon: "fa fa-users menu-icon mr-10",
      //   name: "Followers",
      //   link: `/${this.pName}/${this.pId}/followers`,
      //   sub_menu:[]
      // },
    ];
    this.goToUser(this.router.url);
    if (this.menuList) {
      this.menuList.forEach((val) => {
        if (val.menu) {
          val.menu.forEach((submenu) => {
            if (this.router.url.includes(submenu.type.toLowerCase())) {
              submenu.subMenuActive = true;
            } else {
              submenu.subMenuActive = false;
            }
          });
        }
      });
    }
    this.goToMenu(this.router.url);
    // this.getCategory();
    this.subscriptionRightTabMenuActive = this.commanSubscribeService
      .getLeftTabActiveBasedOnRouterURL()
      .subscribe((message) => {
        if (this.rightsidenav) {
          setTimeout(() => {
            this.rightSideActive();
          }, 2000);
        }
      });
    this.subscriptionRightTabUserActive = this.commanSubscribeService
      .getLeftTabActiveBasedOnRouterURL()
      .subscribe((message) => {
        setTimeout(() => {
          this.rightTabActive();
        }, 1000);
      });

    if (this.userInfo && Object.keys(this.userInfo)?.length > 0) {
      this.getCartProdCount();
    }

    this.getCartProdCountSubscription = this.commanSubscribeService
      .getCartProductCountApi()
      .subscribe((response) => {
        this.getCartProdCount();
      });
  }
  scrollwin() {
    $(window).scroll(function () {
      console.log(window.location.pathname);
      let datan = window.location.pathname;
      // if (!datan.includes('/network-market/product-marketplace/')) {
      if ($(document).scrollTop() > 40) {
        $(".navbar").addClass("affix");
        $(".logo").removeClass("logo-bg");
      } else {
        $(".navbar").removeClass("affix");
        $(".logo").addClass("logo-bg");
      }
      // }
      // else {
      //   if ($(document).scrollTop() > 40) {
      //     $('.navbar').addClass('productHeader');
      //     $('.logo').removeClass('logo-bg');
      //   } else {
      //     $('.navbar').removeClass('productHeader');
      //     $('.logo').addClass('logo-bg');
      //   }
      // }
    });
  }

  async checkAndNavigateToNFT() {
    try {
      this.connectToWallet();
      if (this.walletID) {
        this.router.navigate(["/nft/collections"]);
      }
    } catch (error) {
      this.toastr.error("Please install a wallet to access NFT collections."); // Show error message
    }
  }

  getlink(data, doCallApi?: boolean) {
    this.marketplacetext = "";
    this.marketplacetext =
      data == "event"
        ? "Events"
        : data == "market"
          ? "Merchandise"
          : data == "nft"
            ? "NFT"
            : "";
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    if (data === "event") {
      if (doCallApi !== false) {
        (window as any).umami?.track(`Events Tab Selected - ${userId}`);
        const u_payload = {
          actionType: "event",
          metaData: {
            title: `Events Tab Selected`,
            timeStamp: new Date().toISOString()
          },
           organizationId: this.commanSubscribeService?.slugInfo?.organization_id || null,
          clickAction: `event-type`
        }
        this.commanSubscribeService.sendTriggeredEvent(u_payload);
      }

    } else if (data === "market") {
      if (doCallApi !== false) {
        (window as any).umami?.track(`Merchandise Tab Selected - ${userId}`);
        const u_payload = {
          actionType: "product",
          metaData: {
            title: `Merchandise Tab Selected`,
            timeStamp: new Date().toISOString()
          },
           organizationId: this.commanSubscribeService?.slugInfo?.organization_id || null,
          clickAction: `merchandise`
        }
        this.commanSubscribeService.sendTriggeredEvent(u_payload);
      }

    } else if (data === "nft") {
      if (doCallApi !== false) {
        (window as any).umami?.track(`NFT Tab Selected - ${userId}`);
        const u_payload = {
          actionType: "nft",
          metaData: {
            title: `NFT Tab Selected`,
            timeStamp: new Date().toISOString()
          },
           organizationId: this.commanSubscribeService?.slugInfo?.organization_id || null,
          clickAction: `NFT`
        }
        this.commanSubscribeService.sendTriggeredEvent(u_payload);
      }

    }
  }

  getCryptoBalance() {
    this.commanSubscribeService.getAccountBalance(this.walletID);
  }

  getCartProdCount(from?) {
    let url = MERCH_API.CARTPROD_COUNT;
    let networkGroupId = this.commanSubscribeService.activeGroupId ; 
    if(networkGroupId){
      url += `?networkGroupId=${networkGroupId}`;
    }
    if (this.userInfo && this.userInfo.access_token) {
      this.appPaymentService.getRequest(url).subscribe(
        (response) => {
          if (response.status === 0) {
            this.showCartIcon = true;

            response = response.response.result[0];
            this.cartId = response.cart_id;
            this.cartProdCount = response.cartCount;
            if (this.cartProdCount == 0 && from && from === "cart") {
              let product_info = this.storageService.getItem("product_info");
              if (product_info && product_info.collection_id) {
                this.router.navigateByUrl(
                  "/network-market/product-marketplace/" +
                  product_info.collection_id
                );
              } else {
                this.router.navigateByUrl("/network-market/market");
              }
            }
          } else if (response.status === 1) {
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }

  deleteProductFromCart(itemId, from?) {
    let url = MERCH_API.DELETE_CART_PRODUCT;
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Cart icon closed - ${userId}`);
    const u_payload = {
      actionType: "marketplace",
      metaData: {
        title: `Cart item deleted - ${itemId}`,
        itemId: itemId,
        timeStamp: new Date().toISOString()
      },
       organizationId: this.commanSubscribeService?.slugInfo?.organization_id || null,
      clickAction: `delete`
    }
    this.commanSubscribeService.sendTriggeredEvent(u_payload);
    this.appPaymentService.postRequest(url, { item_id: itemId }).subscribe(
      (response) => {
        if (response.status === 0) {
          this.getCartProdCount(from);
          this.cartProducts = this.cartProducts.filter(
            (product) => product.id !== itemId
          );
          this.toastr.success(response.message);
        } else if (response.status === 1) {
          this.toastr.error(response.message);
        }
      },
      (error) => {
        this.ngxLoader.stop();
        this.toastr.error(error);
      }
    );
  }

  gotoChannel() {
    console.log(this.channelName);
    this.router.navigateByUrl(`/${this.channelName}`);
  }

  changeCurrency(event) {
    let getVal = event.split(" -");
    this.currency = event;
    this.storageService.setItem("currency", getVal[0]);
    this.commanSubscribeService.sendCurrencyInfo(getVal[0]);
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Currency Selected ${getVal[0]} by ${userId}`);
    const data = {
      actionType: "event",
      metaData: {
        title: `Currency Selected ${getVal[0]}`,
        timeStamp: new Date().toISOString()
      },
       organizationId: this.commanSubscribeService?.slugInfo?.organization_id || null,
    }
    this.commanSubscribeService.sendTriggeredEvent(data);
  }

  setCurrency() {
    let cur =
      Object.keys(this.route.snapshot.queryParams).length > 0 &&
        this.route.snapshot.queryParams.currency
        ? this.route.snapshot.queryParams.currency
        : this.getCurrency;
    this.currenciesList.forEach((element) => {
      let getVal = element.split(" -");
      let code = cur
        ? cur
        : this.currentLocation.currency.code.includes('"')
          ? JSON.parse(this.currentLocation.currency.code)
          : this.currentLocation.currency.code;
      if (getVal[0] == code) {
        this.currency = element;
        this.storageService.setItem("currency", getVal[0]);
        this.commanSubscribeService.sendCurrencyInfo(getVal[0]);
      }
    });
  }

  clearSearch() {
    this.searchCurrency = "";
  }

  rightTabActive() {
    this.userList = this.commanSubscribeService.getFilterMenu(
      this.userList,
      this.router.url,
      "allMenu"
    );
  }
  getLiveEvent() {
    this.liveEventSubscr = this.userService
      .getLiveEvents()
      .subscribe((response) => {
        if (response.data.statusCode === "200") {
          let stream_info = response.data.Data.stream_info[0] || {};
          if (
            stream_info.stream_payment_mode == "paid" &&
            response.data.Data.user_subscription_info &&
            response.data.Data.user_subscription_info.length == 0
          ) {
            this.isLiveEvent = false;
          } else {
            this.isLiveEvent = true;
          }
        }
      });
  }

  goBack() {
    // if (this.ticketInfo && this.ticketInfo.ticket_key)
    this.router.navigateByUrl(`${this.router.url.split("/")[1]}/event/schedule/${this.ticket_key}`);
    // else
    //   this.location.back();
  }

  getOrgInfo() {
    this.orgInfoSubscr = this.userService.getOrgInfo().subscribe((response) => {
      this.orgInfo = response;
    });
  }
  goToUser(link, menu?) {
    // this.storageService.deleteItem('eventInfo');
    this.userList = this.commanSubscribeService.getFilterMenu(
      this.userList,
      link,
      menu
    );
    this.router.navigateByUrl(link);
    if (menu) {
      this.rightsidenav.close();
    }
    this.commanSubscribeService.setLeftTabActiveBasedOnRouterURL("");
  }
  goToMenu(link, menu?) {
    // if (Object.keys(this.userInfo)?.length != 0 && !this.userInfo.is_profile_completed &&
    //   link.indexOf("user-dashboard/profile-settings/basic-info") == -1) {
    //   this.toastr.info("Please update your profile details");
    //   this.router.navigateByUrl('/user-dashboard/profile-settings/basic-info');
    //   if (this.rightsidenav) {
    //     this.rightsidenav.close();
    //   }
    //   return;
    // }

    this.menuList = this.commanSubscribeService.getFilterMenu(
      this.menuList,
      link,
      menu
    );
    if (link) {
      this.router.navigateByUrl(link);
    } else if (menu) {
      let obj = this.menuList.filter((m) => m.name == menu.name)[0];
      this.router.navigateByUrl(obj.sub_menu[0].link);
    }
    if (menu && this.rightsidenav) {
      this.rightsidenav.close();
    }
    this.commanSubscribeService.setLeftTabActiveBasedOnRouterURL("");
  }
  navigateSubmenu(data) {
    // if (Object.keys(this.userInfo)?.length != 0 && !this.userInfo.is_profile_completed &&
    //   data.indexOf("user-dashboard/profile-settings/basic-info") == -1) {
    //   this.toastr.info("Please update your profile details");
    //   this.router.navigateByUrl('/user-dashboard/profile-settings/basic-info');
    //   if (this.rightsidenav) {
    //     this.rightsidenav.close();
    //   }
    //   return;
    // }

    this.menuList = this.commanSubscribeService.getFilterMenu(
      this.menuList,
      data,
      "subMenu"
    );
    this.rightsidenav.close();
    this.router.navigateByUrl(data);
    this.commanSubscribeService.setLeftTabActiveBasedOnRouterURL("");
  }

  rightSideActive() {
    this.menuList = this.commanSubscribeService.getFilterMenu(
      this.menuList,
      this.router.url,
      "allMenu"
    );
    this.rightsidenav.close();
  }

  redirectTo(path) {
    if (path != "signin" && path != "signup")
      this.storageService.deleteItem("eventInfo");
    this.storageService.deleteItem("isEvent");
    // this.sidenav.close();
    if (path == "signin") {
      if (this.router.url.includes("/network-market/")) {
        this.storageService.setItem("skipRedirection", "yes");
      }
      this.landingPageService.openConsumerSignIn();
    } else {
      this.router.navigateByUrl(path);
    }
  }

  goToRespectiveScreen(path, type) {
    this.storageService.deleteItem("eventInfo");
    this.storageService.deleteItem("isEvent");
    if (path == "home") this.router.navigateByUrl("");
    else this.router.navigateByUrl(path);
    if (type == "sidenav") this.sidenav.close();
  }

  goToMainScreen() {
    this.storageService.deleteItem("eventInfo");
    this.storageService.deleteItem("isEvent");
    if (this.currentChannelName) {
      this.router.navigateByUrl('/' + this.currentChannelName);
    } else {
      this.router.navigateByUrl("");
    }
  }

  getName() {
    if (this.userInfo) {
      if (this.userInfo.user_display_name) {
        let name;
        if (
          this.userInfo.user_display_name &&
          this.userInfo.user_display_name.includes(" ")
        ) {
          name = this.userInfo.user_display_name.split(" ");
          console.log(name, "nameee");
          console.log(this.userInfo.user_display_name, "user_display_name");
          if (name[0] && !name[1] && name[1] != "") {
            this.displayName = name[0][0] + name[0][1];
          } else if (name[1][0] != undefined) {
            this.displayName = name[0][0] + (name[2] ? name[2][0] : name[1][0]);
          } else {
            this.displayName = this.userInfo.user_display_name[0];
          }
        } else if (this.userInfo.user_display_name[1] != undefined) {
          this.displayName =
            this.userInfo.user_display_name[0] +
            this.userInfo.user_display_name[1];
        } else {
          this.displayName = this.userInfo.user_display_name[0];
        }
        // this.displayName = this.userInfo.user_first_name[0] + this.userInfo.user_last_name[0];
        this.profileName = this.userInfo.user_display_name;
        // this.profileName = this.userInfo.user_first_name + " " + this.userInfo.user_last_name;
      } else if (this.userInfo.user_first_name) {
        this.displayName =
          this.userInfo.user_first_name[0] + this.userInfo.user_first_name[1];
        this.profileName = this.userInfo.user_first_name;
      } else if (this.userInfo.user_email) {
        this.displayName =
          this.userInfo.user_email[0] + this.userInfo.user_email[1];
      }
    }
  }

  signOutFromOL(callBack) {
    this.signout();
  }



signout() {
  this.storageService.deleteItem("eventInfo");
  this.storageService.deleteItem("isEvent");
  this.ngxLoader.start();

  // Step 1: Call your backend logout API first
  this.appService.postRequest(API.FAN_LOGOUT, "").subscribe(
    (result) => {
      this.ngxLoader.stop();

      if (result["status"] == 0) {
        // Step 2: Clear all local app state
        this.loggedIn = false;
        localStorage.isFanLoginUser = false;
        this.storageService.deleteItem("isAffiliateUser");
        this.storageService.deleteItem("user_Info");
        this.storageService.deleteItem("ticket_key");
        this.storageService.deleteItem("product_info");
        this.storageService.deleteItem("signInRouteData");
        this.storageService.deleteItem("redirectUrlAfterGoogleLogin");
        sessionStorage.removeItem('oidcAttempted');
        this.commanSubscribeService.sendTriggeredEvent({ actionType: 'sign-out', actionName: 'USER_LOGOUT', organizationId: this.commanSubscribeService.orgId || null });
        this.commanSubscribeService.sendUserInfo({});
        this.commanSubscribeService.sendMylistData([]);
        this.userInfo = {};
        this.rightsidenav.close();
        this.web3service.signout();

        // Step 3: Trigger OneLogin logout (OIDC)
        const ONELOGIN_DOMAIN = `${environment.OIDC.onelogin_account_name}.onelogin.com`;//environment.onelogin_domain;
        const POST_LOGOUT_REDIRECT_URI = environment.social_auth_redirect_uri;
        // const POST_LOGOUT_REDIRECT_URI = "http://localhost:4200/";
        const ID_TOKEN = localStorage.getItem("id_token");

        if (ID_TOKEN) {
          const formattedIdToken = ID_TOKEN.replace(/^"|"$/g, ""); // remove extra quotes
          const logoutUrl =
            `https://${ONELOGIN_DOMAIN}/oidc/2/logout` +
            `?id_token_hint=${encodeURIComponent(formattedIdToken)}` +
            `&post_logout_redirect_uri=${encodeURIComponent(POST_LOGOUT_REDIRECT_URI)}`;

          window.location.href = logoutUrl; // redirect to OneLogin logout page
        } else {
          localStorage.clear();
          window.location.href = POST_LOGOUT_REDIRECT_URI;
        }

      } else {
        this.ngxLoader.stop();
        this.toastr.error(result["message"]);
      }
    },
    (error) => {
      this.ngxLoader.stop();
      console.log(error);
    }
  );
}


  openKoopid() {
    this.openChat = !this.openChat;
  }
  connectPubNubChannels() {
    this.pubnubService.connect(this.user_id.toString(), (success, error) => {
      if (error) {
        console.log("Error while connecting chat user", error);
        this.isPubnubChannelAvailable = false;
        // this.toastr.error("Error while connecting chat user");
        return;
      } else {
        this.pubnubService.enterChannel(
          this.event_id + "_notifications",
          1,
          (openChannel, error) => {
            if (error) {
              console.log("Error while connecting chat channel", error);
              this.isPubnubChannelAvailable = false;
              // this.toastr.error("Channel not available");
              return;
            }
            this.isPubnubChannelAvailable = true;
            this.openPubNubChannel = openChannel;
          }
        );
      }
    });
    this.pubnubService.receiveMessages(
      this.event_id + "_notifications",
      (response) => {
        console.log("subScribeChannelHandler::", response);
        let channel = response.channel;
        let message = response.message;
        if (
          channel &&
          this.openPubNubChannel &&
          channel == this.openPubNubChannel &&
          message.customType == "NETWORKING" &&
          message.data != ""
        ) {
          this.isNetworkNotification = true;
          let data = JSON.parse(message.data);
          this.message = message.message;
          this.inviteKey =
            environment.CONSUMER_PORTAL +
            `${this.router.url.split("/")[1]}/event/networking-list/` +
            this.ticket_key +
            "/" +
            data.id;
          console.log("this.isNetworkNotification", this.isNetworkNotification);
          setTimeout(() => {
            this.closeBox();
          }, 10000);
        }
      }
    );
  }
  closeBox() {
    this.isNetworkNotification = false;
  }
  copyToClipboard(type) {
    // if (this.eventInfo.publish == 1) {
    const el = document.createElement("textarea");
    el.value = this.inviteKey;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    this.isNetworkNotification = false;
    this.toastr.success("Copied..!");
    // } else {
    //   this.toastr.info('Please publish the event');
    // }
  }
  joinUrl() {
    this.isNetworkNotification = false;
    window.open(this.inviteKey, "_blank");
  }

  async connectToWallet() {
    this.web3service.setNetwork(environment.clientDetails.network_name);
    await this.web3service
      .checkAndInstantiateWeb3()
      .then((isweb3) => {
        console.log("isweb3", isweb3);
        if (isweb3 === "connected") {
          this.web3service.setContract();
          this.web3service.connectAccount().then((res) => {
            console.log("before get account balance", res);
            this.walletID = res;
            this.commanSubscribeService.getAccountBalance(this.walletID);
            console.log("after get account balance");
          });
        }
      })
      .catch((e) => {
        console.log(e);
        this.dialog.open(WalletConnectDialogComponent, {
          panelClass: "app-consumer-sign-in",
          hasBackdrop: true,
          data: {
            text: !this.nftNavigation
              ? "Please install wallet to continue with NFT"
              : "",
          },
        });
        this.nftNavigation = false;
      });
  }

  ngOnDestroy() {
    this.pubnubService.disconnect([this.event_id + "_notifications"]);
    if (this.subscriptionRightTabMenuActive)
      this.subscriptionRightTabMenuActive.unsubscribe();
    if (this.userInfoSubscription) this.userInfoSubscription.unsubscribe();
    if (this.publisherStreamSubscription) {
      this.publisherStreamSubscription.unsubscribe();
    }
    if (this.orgInfoSubscr) {
      this.orgInfoSubscr.unsubscribe();
    }
    if (this.liveEventSubscr) {
      this.liveEventSubscr.unsubscribe();
    }
    if (this.subscriptionRightTabUserActive) {
      this.subscriptionRightTabUserActive.unsubscribe();
    }
    if (this.routerevents) {
      this.routerevents.unsubscribe();
    }
    if (this.expoInfoSubscr) this.expoInfoSubscr.unsubscribe();
    if (this.ticketStatus) this.ticketStatus.unsubscribe();
    if (this.getCartProdCountSubscription)
      this.getCartProdCountSubscription.unsubscribe();
  }

  closePopup() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Cart icon closed - ${userId}`);
    const u_payload = {
      actionType: "marketplace",
      metaData: {
        title: `Cart icon closed`,
        timeStamp: new Date().toISOString()
      },
       organizationId: this.commanSubscribeService?.slugInfo?.organization_id || null,
      clickAction: `event-type`
    }
    this.commanSubscribeService.sendTriggeredEvent(u_payload);
    this.copyLinkPopup = false;
  }

  trackMyListClick() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`My List Clicked by ${userId}`)
    const data = {
      actionType: "event",
      metaData: {
        title: "My List Clicked",
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commanSubscribeService?.slugInfo?.organization_id || null,
    }
    this.commanSubscribeService.sendTriggeredEvent(data);
  }

}
